<template>
    <b-modal
      v-model="value"
      no-close-on-backdrop
      no-close-on-esc
      dialog-class="mc-modal-warning"
      scrollable
      :size="size"
      centered
    >
      <div class="card-body p-2">
        <slot name="content-message">
          <p>{{ msg }}</p>
        </slot>
      </div>
      <template #modal-header>
        <div class="text-white">{{ title }}</div>
      </template>
      <template #modal-footer>
        <div class="d-flex mx-0">
          <slot name="button-action">
            <McButton @click="$router.go(-1)" variant="secondary" class="me-2" :text="$t('global.back')" />
            <McButton @click="$router.push({ name: 'Integration' })" variant="primary" :text="$t('global.goToSetting')" />
          </slot>
        </div>
      </template>
    </b-modal>
  </template>
  <script>
  import McButton from '@/components/McButton'
  export default {
    components: {
      McButton
    },
    props: {
      value: {
        type: Boolean,
        require: true
      },
      title: {
        type: String,
        require: true
      },
      msg: {
        type: String,
        require: true
      },
      size: {
        type: String,
        default: 'md'
      }
    }
  }
  </script>